import { inject, Injectable } from '@angular/core';
import { EnumService as MasterdataEnumService } from '@backoffice-frontend/shared/bo/util-masterdata';
import type { EnumValue } from '@clean-code/models/common';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  private enumService = inject(MasterdataEnumService);

  getEnumType$(enumType: string, url?: string): Observable<EnumValue[]> {
    return this.enumService.getEnumType$(enumType, url);
  }
}
